module.exports = __webpack_public_path__ + "img/adn_konecta.d92dc8d6.svg";